import { createTranslations } from '@npco/utils-translations'

export const setupFlowAccountDetailsTranslations = createTranslations({
  yourFirstAccount: 'Your First Account',
  accountNameTablet: 'Name',
  bsb: 'BSB',
  accountNumber: 'Number',
})
